<ng-template #customCellTemplate let-day="day" let-locale="locale">
    <div class="tw-flex tw-flex-col tw-m-2 tw-h-[118px]">
        <label class="tw-font-semibold cal-day-number tw-text-sm">{{
            day.date.getDate()
        }}</label>
        <div
            *ngFor="let event of day.events; let i = index"
            class="tw-flex tw-flex-row tw-justify-between tw-text-xs tw-mb-1 tw-rounded-2xl tw-px-2 tw-py-1"
            [ngClass]="event.pastDate ? 'tw-bg-[#D5D4D4]' : event.meta.class"
            (click)="scrollToEvent(event.id)"
        >
            <div
                class="tw-font-semibold"
                [ngClass]="
                    event.pastDate ? 'tw-text-[#9D9999]' : 'tw-text-black'
                "
            >
                {{ event.tags | translate }}
            </div>
            <div
                class="tw-font-bold"
                [ngClass]="
                    event.pastDate ? 'tw-text-[#9D9999]' : 'tw-text-black'
                "
                placement="top"
                ngbTooltip="{{ event.title }}"
            >
                {{
                    event.title.length > 7
                        ? (event.title | slice : 0 : 7) + "..."
                        : event.title
                }}
            </div>
        </div>
    </div>
</ng-template>

<div class="tw-text-2xl tw-font-semibold tw-mb-8">
    {{ heading | translate }}
</div>

<div class="tw-flex tw-items-start tw-justify-between md:tw-mx-6">
    <div
        class="tw-w-[25%] tw-p-[23px] tw-border-[1px_solid_rgba(216,216,216,1)] tw-shadow-[2px_4px_24px_0px_rgba(221,221,221,1)] tw-mt-[70px] tw-rounded-2xl tw-flex tw-flex-col tw-gap-6"
    >
        <!-- filter for main category starts -->
        <div class="tw-flex tw-items-center tw-gap-4">
            <input
                type="checkbox"
                class="tw-w-[19px] tw-h-[19px] tw-accent-red-600"
                [checked]="checkboxStates['Advisory Workshops']"
                (click)="onFilterProduct($event, 'Advisory Workshops')"
            />
            <div class="tw-text-black tw-font-semibold tw-text-lg">
                {{ "LNDP_CALENDAR.ADVISORY_WORKSHOP" | translate }}
            </div>
        </div>
        <!-- filter for subcategories starts -->
        <div class="tw-text-gray-500 tw-font-semibold">Sub-Categories</div>
        <div class="tw-flex tw-flex-col tw-gap-4">
            <div class="tw-flex tw-items-center tw-gap-4">
                <input
                    type="checkbox"
                    class="tw-w-[19px] tw-h-[19px] tw-accent-red-600"
                    [checked]="checkboxStates['Business Plan']"
                    (click)="onFilterProduct($event, 'Business Plan')"
                />
                <div class="tw-text-black tw-font-semibold tw-text-lg">
                    {{ "LNDP_CALENDAR.BUSINESS_PLAN" | translate }}
                </div>
            </div>
        </div>
        <div class="tw-flex tw-flex-col tw-gap-4">
            <div class="tw-flex tw-items-center tw-gap-4">
                <input
                    type="checkbox"
                    class="tw-w-[19px] tw-h-[19px] tw-accent-red-600"
                    [checked]="checkboxStates['Financial Literacy']"
                    (click)="onFilterProduct($event, 'Financial Literacy')"
                />
                <div class="tw-text-black tw-font-semibold tw-text-lg">
                    {{ "LNDP_CALENDAR.FINANCIAL_LITERACY" | translate }}
                </div>
            </div>
        </div>
        <div class="tw-flex tw-flex-col tw-gap-4">
            <div class="tw-flex tw-items-center tw-gap-4">
                <input
                    type="checkbox"
                    class="tw-w-[19px] tw-h-[19px] tw-accent-red-600"
                    [checked]="checkboxStates['Marketing and Sales']"
                    (click)="onFilterProduct($event, 'Marketing and Sales')"
                />
                <div class="tw-text-black tw-font-semibold tw-text-lg">
                    {{ "LNDP_CALENDAR.MARKETING_SALES" | translate }}
                </div>
            </div>
        </div>
        <div class="tw-flex tw-flex-col tw-gap-4">
            <div class="tw-flex tw-items-center tw-gap-4">
                <input
                    type="checkbox"
                    class="tw-w-[19px] tw-h-[19px] tw-accent-red-600"
                    [checked]="checkboxStates['Halal']"
                    (click)="onFilterProduct($event, 'Halal')"
                />
                <div class="tw-text-black tw-font-semibold tw-text-lg">
                    {{ "LNDP_CALENDAR.HALAL" | translate }}
                </div>
            </div>
        </div>
        <div class="tw-flex tw-flex-col tw-gap-4">
            <div class="tw-flex tw-items-center tw-gap-4">
                <input
                    type="checkbox"
                    class="tw-w-[19px] tw-h-[19px] tw-accent-red-600"
                    [checked]="checkboxStates['ESG']"
                    (click)="onFilterProduct($event, 'ESG')"
                />
                <div class="tw-text-black tw-font-semibold tw-text-lg">
                    {{ "COMMON.ESG" | translate }}
                </div>
            </div>
        </div>
        <div class="tw-flex tw-flex-col tw-gap-4">
            <div class="tw-flex tw-items-center tw-gap-4">
                <input
                    type="checkbox"
                    class="tw-w-[19px] tw-h-[19px] tw-accent-red-600"
                    [checked]="checkboxStates['Business Expansion']"
                    (click)="onFilterProduct($event, 'Business Expansion')"
                />
                <div class="tw-text-black tw-font-semibold tw-text-lg">
                    {{ "LNDP_CALENDAR.BUSINESS_EXPANSION" | translate }}
                </div>
            </div>
        </div>
        <div class="tw-h-[1px] tw-bg-gray-200 tw-w-full"></div>
        <!-- filter for subcategories ends -->
        <div class="tw-flex tw-items-center tw-gap-4">
            <input
                type="checkbox"
                class="tw-w-[19px] tw-h-[19px] tw-accent-yellow-400"
                [checked]="checkboxStates['Access New Markets']"
                (click)="onFilterProduct($event, 'Access New Markets')"
            />
            <div class="tw-text-black tw-font-semibold tw-text-lg">
                {{ "LNDP_CALENDAR.ACCESS_NEW_MARKETS" | translate }}
            </div>
        </div>
        <div class="tw-flex tw-items-center tw-gap-4">
            <input
                type="checkbox"
                class="tw-w-[19px] tw-h-[19px] tw-accent-green-700"
                [checked]="checkboxStates['Networking Sessions']"
                (click)="onFilterProduct($event, 'Networking Sessions')"
            />
            <div class="tw-text-black tw-font-semibold tw-text-lg">
                {{ "LNDP_CALENDAR.NETWORKING_SESSION" | translate }}
            </div>
        </div>
        <!-- filter for main category ends -->
    </div>
    <div class="tw-w-[73%] tw-flex tw-flex-col">
        <div class="tw-flex tw-flex-row tw-justify-between mb-3 tw-w-full">
            <span class="tw-font-semibold tw-text-lg">
                {{ viewDate | calendarDate : view + "ViewTitle" : readLocalStorageValue('language') }}
            </span>
            <div class="tw-flex">
                <mat-icon
                    mwlCalendarPreviousView
                    [view]="view"
                    [(viewDate)]="viewDate"
                    (viewDateChange)="closeOpenMonthViewDay()"
                    class="tw-cursor-pointer"
                >
                    chevron_left
                </mat-icon>
                <div class="tw-w-4"></div>
                <mat-icon
                    mwlCalendarNextView
                    [view]="view"
                    [(viewDate)]="viewDate"
                    (viewDateChange)="closeOpenMonthViewDay()"
                    class="tw-cursor-pointer"
                >
                    chevron_right
                </mat-icon>
            </div>
        </div>
        <mwl-calendar-month-view
            [viewDate]="viewDate"
            [events]="events"
            [refresh]="refresh"
            [cellTemplate]="customCellTemplate"
            [locale]="readLocalStorageValue('language')"
        />
        <div
            class="tw-flex tw-px-4 tw-py-3 tw-border-gray-200 tw-border-[1px] tw-mt-3 tw-rounded tw-justify-around tw-w-full"
        >
            <div
                class="tw-flex tw-items-center"
                *ngFor="let category of eventCategories"
            >
                <div class="tw-w-4 tw-h-4 tw-mr-2  {{ category.color }}"></div>
                <div>{{ category.label | translate }}</div>
            </div>
        </div>
        <app-calendar-events [events]="events" (pickedLanguage)="changeMonthLanguage($event)"/>
    </div>
</div>

<!-- List of calendar events ends -->

<div class="tw-flex tw-my-10" *ngIf="events?.length == 0">
    <div class="tw-flex tw-flex-col tw-m-5 tw-flex-1 tw-ml-[52px]">
        <div class="tw-text-xl tw-font-semibold tw-mb-4 text-center">
            {{ "LNDP_CALENDAR.NO_EVENTS" | translate }}
        </div>
    </div>
</div>
<app-loader [showLoader]="!apiResponse"></app-loader>